import pricingTool from './pricingTool'

export default pricingTool
